module.exports = __webpack_public_path__ + "img/banner.c4cf7cb0.png";